<template>
  <div>
    <div>
      <div class="modal-header py-2 pt-3"  style="background: #162C4D;">
        <h5 class="text-white">{{$ml.get('CREATE_ACTION_V2')}}</h5>
        <button type="button" id="closeActivity" class="close pb-3 pt-2" style="color: #8092AB;" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" class="font-40">&times;</span>
        </button>
      </div>
      <div class="modal-header py-0">
        <ul class="row nav hpx-50 px-3 mincrm-dynamic-tabs"  role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="deal-tab" data-toggle="tab" href="#deal" role="tab" aria-controls="deal" aria-selected="true">{{$ml.get('CREATE_DEAL')}}  
            </a>
          </li>
        </ul>
      </div>

      <div class="modal-body pt-3 px-md-4">
        <div class="tab-content">
          <div class="tab-pane fade show active pt-2 pb-3" style="border-bottom:1px solid #DEDFE1;" id="deal" role="tabpanel" aria-labelledby="deal-tab">
            <div class="dealStatus mb-3 tabletSlide">
              <div class="row m-0">
                <div class="col-md-3 statu" id="1" @click="selectStage">
                  <button type="button" class="btn btn-sm btn-block active font-sm border-top-bottom-left-radius-4">{{$ml.get('STEP_1')}}</button>
                </div>
                <div class="col-md-3 statu" id="2" @click="selectStage">
                  <button type="button" v-if="deal['stageId']>=2" class="btn btn-sm btn-block active font-sm">{{$ml.get('STEP_2')}}</button>
                  <button type="button" v-else class="btn btn-sm btn-block font-sm">{{$ml.get('STEP_2')}}</button>
                </div>
                <div class="col-md-3 statu" id="3" @click="selectStage">
                  <button type="button" v-if="deal['stageId']>=3" class="btn btn-sm btn-block active font-sm">{{$ml.get('STEP_3')}}</button>
                  <button type="button" v-else class="btn btn-sm btn-block font-sm">{{$ml.get('STEP_3')}}</button>
                </div>
                <div class="col-md-3 statu" id="4" @click="selectStage">
                  <button type="button" v-if="deal['stageId']>=4" class="btn btn-sm btn-block active font-sm border-top-bottom-right-radius-4">{{$ml.get('STEP_4')}}</button>
                  <button type="button" v-else class="btn btn-sm btn-block font-sm border-top-bottom-right-radius-4">{{$ml.get('STEP_4')}}</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="border-right:1px solid #DEDFE1;">
                <div>
                  <label class="new-label">{{$ml.get('OPPORTUNITY_NAME')}}*</label>
                  <input type="text" v-model="deal['title']" class="new-input">
                </div>

                <div>
                  <div class="row">
                    <div class="col-12">
                      <label class="new-label">Fırsat Sahibi*</label>
                      <button type="button" class="h-36 bg-white select-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{assignedValueTitle}}
                      <i class="fa fa-angle-down pull-right ml-2"></i>
                      </button>
                      <div class="dropdown-menu dropdown-menu-left multiChoose p-0">
                        <ul class="new-dropdown p-0 border-0">
                          <template v-for="u in users" :key="u && u._id ? u._id.$oid : u.name">
                            <li v-if="u && (u.x || (u._id && u._id.$oid == assignedValue))" @click="assignedValue=u._id.$oid,assignedValueTitle=u.name+' '+u.surName" :disabled="!u.x" :class="{'active-user':!u.x}">{{u.name}} {{u.surName}}</li>
                          </template>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="d-flex justify-content-between ">
                    <label class="new-label">{{$ml.get('VALUE')}}</label>
                    <label class="new-label">{{$ml.get('CURRENCY')}}</label>
                  </div>
                  <div class="input-group d-flex currency-group">
                    <input type="number" v-model.number="deal['value']" class="col-7 col-md-8 new-input form-control" style="height: 45px;">
                    <select class="custom-select" style="height: 45px;" v-model="deal['currency']" @change="changeCurrency($event)">
                      <option v-for="(cur,ind) in currencyData()" v-bind:key="ind" :value="cur.id">{{cur.label}}</option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <label class="new-label">{{$ml.get('ASSOCIATE_WITH_PRODUCT')}}</label>
                    <input type="text" v-model="productKeyword" class="new-input">
                    <ul class="new-dropdown autocomplete-results" v-show='isHiddenProduct'>
                      <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'product')">{{result.name}}</li>
                      <li class="autocomplete-result" v-if="items.length<1"> {{$ml.get('NOT_FIND')}}!!</li>
                    </ul>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-12">
                    <table class="mcTable">
                      <thead>
                        <tr>
                          <th>{{$ml.get('PRODUCT_NAME')}}</th>
                          <th>{{$ml.get('PRICE')}}</th>
                          <th>{{$ml.get('PIECE')}}</th>
                          <th>{{$ml.get('DISCOUNT')}}(%)</th>
                          <th>{{$ml.get('TOTAL')}}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(i,index) in selectedProductList" :key="index">
                          <td class="w-100">{{i.name}}</td>
                          <td v-if="i.prices!=undefined">
                            <span v-if="i.prices.find(price => price.currency==deal['currency'])!=undefined">
                              {{i.prices.find(price => price.currency==deal['currency']).price}}
                            </span>
                            <span v-else>0</span>
                          </td>
                          <td v-else>0</td>
                          <td v-if="i.prices!==undefined"><input type="number" onwheel="this.blur()" min="0" class="w-100" style="text-align: center;border: 0px;" @input="updateProductPriceList()" value="1" v-model.number="selectedProductList[index].quantity"/> </td>
                          <td v-if="i.prices!==undefined"><input type="number" onwheel="this.blur()" min="0" max="100" class="w-100" style="text-align: center;border: 0px;" @input="updateProductPriceList()" value="0" v-model.number="selectedProductList[index].discountPercentage"/></td>
                          <td v-if="i.prices===undefined"><input type="number" onwheel="this.blur()" min="0" class="w-100" style="text-align: center;border: 0px;" @input="updateProductPriceList()" value="1" v-model.number="selectedProductList[index].quantity"/> </td>
                          <td v-if="i.prices===undefined"><input type="number" onwheel="this.blur()" min="0" max="100" class="w-100" style="text-align: center;border: 0px;" @input="updateProductPriceList()" value="0" v-model.number="selectedProductList[index].discountPercentage"/></td>
                          <td v-text="selectedProductList[index].totalPrice"></td>
                          <td><i style="padding-right: 6px;" @click="removeProduct(index)" class="icon-line-iptal f-14"></i></td>
                        </tr>
                        <tr v-show="selectedProductList<1">
                          <td>{{$ml.get('NO_PRODUCT_ASSOCIATED')}}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div>
                  <label class="new-label">{{$ml.get('PROBABILITY_PERCENTAGE')}}</label>
                  <div class="inputInfo">
                      <input type="text" value="20" disabled class="new-input input-readonly">
                      <span class="bg-gray position-absolute">%</span>
                  </div>
                </div>

                <div class="d-flex">
                  <div class="col-6 pl-0">
                    <label class="new-label">{{$ml.get('SOURCE')}}</label>
                    <div class="wrapSelect bg-white">
                      <v-select :options="soruceTitle" :reduce="label => label.value" label="label" v-model="deal['source']" :searchable="false"/>
                    </div>
                  </div>
                  <div class="col-6 pr-0">
                    <label class="new-label">{{$ml.get('DEGREE')}}</label>
                    <div class="wrapSelect bg-white rateIcon">
                      <v-select :options="rateTitle" :reduce="label => label.value" label="label" v-model="deal['rate']" :searchable="false"/>
                    </div>
                  </div>
                </div>

                <div>
                  <label class="new-label">{{$ml.get('NOTE')}}</label>
                  <textarea type="text" v-if="!listenStateStatus" v-model="note" class="new-textarea"></textarea>
                  <div v-else>
                    <input v-model="addNote" type="text" placeholder="Not Ekle..." class="updateInput font-family-bold f-14 f-w-normal">
                    <i @click="addNoteFunc" class="icon-line-yesiltik btn-click"></i>
                    <i class="icon-line-iptal iptal btn-click"></i>

                    <div v-if="deal['notes']!=undefined">
                      <showNotePanel :data="deal['notes']"  :users="this.users"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <p class="font-family-bold mb-0" style="color: #7F8FA4;">{{$ml.get('ESTIMATED_CLOSING')}}</p>
            <!-- fromCreationDate kısmı -->
            <div class="row mb-4 d-flex align-items-center">
              <div class="col-md-5">
                <input type="radio" id="fromCreationDate" @click="fromCreationDateSection" value="fromCreationDate" v-model="pickedDealDate">
                <label class="ml-2 mt-2" style="word-spacing: 2px;" for="fromCreationDate">Başlangıç tarihinden</label>
              </div>
              <div class="col-md-5 ml-3">
                <div class="row" id="fromCreationDateSectionID" style="pointer-events: none;">
                  <div class="row">
                    <div class="col-sm-3">
                      <label class="new-label mb-1">{{$ml.get('DAY')}}</label>
                      <input type="number" v-model="activityDelayDay" placeholder="0" style="height: 34px;" class="new-input mb-2" />
                    </div>
                    <div class="col-sm-3">
                      <label class="new-label mb-1">{{$ml.get('HOUR')}}</label>
                      <input type="number" v-model="activityDelayHour" placeholder="0" style="height: 34px;" class="new-input mb-2" />
                    </div>
                    <div class="col-sm-3">
                      <label class="new-label mb-1">{{$ml.get('MINUTE')}}</label>
                      <input type="number" v-model="activityDelayMinute" placeholder="0" style="height: 34px;" class="new-input mb-2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- predefinedDate kısmı -->
            <div class="row mb-4">
              <div class="col-md-3">
                <input type="radio" id="predefinedDate" @click="predefinedDateSection" value="predefinedDate" v-model="pickedDealDate">
                <label class="ml-2 mt-2 text-dark" style="word-spacing: 2px;" for="predefinedDate">{{$ml.get('ON_A_PREDEFINED_DATE')}}</label>
              </div>
              <div class="col-md-6">
                <div class="row" id="predefinedDateSectionID" style="pointer-events: none;">
                  <div class="col-sm-6 mb-2">
                    <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityDateWorkflow" :label="$ml.get('SELECT_DATE')" class="new-ctk" v-model="activityDateWorkflow" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                      
                  </div>
                  <div class="col-sm-4">
                    <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityTime2" :label="$ml.get('TIME')" v-model="activityTime2" class="new-ctk" format="HH:mm" formatted="HH:mm"  :noLabel="true" :range="false" :onlyTime="true"></vue-ctk-date-time-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-4 mt-3 crm-modal-footer stickyBtn">
          <hr class="col-12 d-none d-md-none">
          <div class="col-12 dealBtnStyle">
            <button class="btn-new save" @click="activityProceed()">{{$ml.get('PROCEED_V2')}}</button>
            <button class="btn-new" @click="closeButton">{{$ml.get('CANCEL')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import axios from "axios";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
Vue.component("vue-ctk-date-time-picker", VueCtkDateTimePicker);
import _ from "underscore";
import showNotePanel from "@/components/showNotePanel";

export default {
  name: "newDeal",
  props: ["methods", "customFieldArray", "user", "users", "data", "modalClear","updateAction"],
  components: {
    showNotePanel: showNotePanel,
  },
  data() {
    return {
      watchUpdated:0,
      deal: {
        stageId: 1,
        status : 1,
        value: 0,
        currency: localStorage.defaultCurrency,
        rate: "0",
        source: "0",
        notes: [],
        dealOwner:"",
        title:"",
      },
      dealId: "",
      customerFiles:[],
      returnCustomField: [],
      items: [],
      productTableList:[],
      organizations: [],
      contacts: [],
      personData:[],
      organizationData:[],
      contactKeyword: "",
      contactKeySearch: true,
      selectContact: "",
      organizationsKeyword: "",
      organizationsWord:"",
      orgKeySearch: true,
      selectOrganization: "",
      relatedDeal:"",
      currencyValue:"",
      organizationId: "",
      productId: "",
      contactId: "",
      isHiddenContact: false,
      isHiddenOrganization: false,
      isHiddenProduct: false,
      lostReason: "",
      note: "",
      productKeyword: "",
      selectProduct: "",
      selectAll:false,
      selected:[],
      selectedPersons:[],
      listPersons:[],
      personIds:[],
      isEditable:false,
      isEditableBill:false,
      isEditableShipping:false,
      billAddress:"",
      shippingAddress:"",
      referenceNo:"",
      currencyText:"",
      product: [],
      selectedProductList: [],
      addContact: false,
      addOrg: false,
      addOrgArray: { isCandidate: true },
      addContactArray: [],
      isNewOrganization: false,
      addnote: "",
      assignedValueTitle:"Seçiniz",
      assignedValue:"",
      soruceTitle: [
        { value: "0", label: this.$ml.get("SELECT") },
        {
          value: this.$ml.get("ADVERTISING"),
          label: this.$ml.get("ADVERTISING"),
        },
        {
          value: this.$ml.get("PHONE_CALL"),
          label: this.$ml.get("PHONE_CALL"),
        },
        {
          value: this.$ml.get("EMPLOYEE_ORUENTATION"),
          label: this.$ml.get("EMPLOYEE_ORUENTATION"),
        },
        {
          value: this.$ml.get("EXTERNAL_ORUENTATION"),
          label: this.$ml.get("EXTERNAL_ORUENTATION"),
        },
        {
          value: this.$ml.get("ONLINE_STORE"),
          label: this.$ml.get("ONLINE_STORE"),
        },
        {
          value: this.$ml.get("BUSINES_PARTNER"),
          label: this.$ml.get("BUSINES_PARTNER"),
        },
        {
          value: this.$ml.get("PUBLIC_RELATIONS"),
          label: this.$ml.get("PUBLIC_RELATIONS"),
        },
        { value: this.$ml.get("SEMINAR"), label: this.$ml.get("SEMINAR") },
        { value: this.$ml.get("FAIR"), label: this.$ml.get("FAIR") },
        { value: "Web", label: "Web" },
        { value: this.$ml.get("EMAILING"), label: this.$ml.get("EMAILING") },
        {
          value: this.$ml.get("SOCIAL_MEDIA"),
          label: this.$ml.get("SOCIAL_MEDIA"),
        },
        {
          value: this.$ml.get("AFFILIATE_PROGRAMS"),
          label: this.$ml.get("AFFILIATE_PROGRAMS"),
        },
        { value: this.$ml.get("SEO"), label: this.$ml.get("SEO") },
        {
          value: this.$ml.get("PAID_SEARCH"),
          label: this.$ml.get("PAID_SEARCH"),
        },
        {
          value: this.$ml.get("ONLINE_ADVERTISING"),
          label: this.$ml.get("ONLINE_ADVERTISING"),
        },
      ],
      rateTitle: [
        { value: "0", label: this.$ml.get("SELECT") },
        { value: "1", label: this.$ml.get("NORMAL") },
        { value: "2", label: this.$ml.get("PRIORITY") },
        { value: "3", label: this.$ml.get("URGENT") },
      ],
      customerType: [
        { value: true, label: this.$ml.get("LEAD") },
        { value: false, label: this.$ml.get("CUSTOMER") },
      ],
      currenciesData: [
        { value: "1", label: "TL" },
        { value: "2", label: "USD" },
        { value: "3", label: "EUR" },
        { value: "4", label: "AUD" },
        { value: "5", label: "DKK" },
        { value: "6", label: "GBP" },
        { value: "7", label: "CHF" },
        { value: "8", label: "SEK" },
        { value: "9", label: "CAD" },
        { value: "10", label:"KWD" },
        { value: "11", label:"NOK" },
        { value: "12", label:"SAR" },
        { value: "13", label:"JPY" },
        { value: "14", label:"BGN" },
        { value: "15", label:"RON" },
        { value: "16", label:"RUB" },
        { value: "17", label:"IRR" },
        { value: "18", label:"CNY" },
        { value: "19", label:"PKR" },
        { value: "20", label:"QAR" },
      ],
      orjinalProductList: [],
      reminders: [
        {
          day: "",
          time: "12:00",
          date: { $date: "" },
          isActive: true,
          isQueued: false,
          firstLoad: true,
        },
      ],
      customFieldDatas: [],
      newDealChecker: true,
      activityDateAction: "",

      pageIs: "newDeal",

      totalProductAmount:0,
      totalAmount:0,
      totalDiscount:0,
      totalTaxes:0,
      subTotal:0,
      totalKDV:0,
      totalOTV:0,
      generalTotal:0,
      emailTemplates:[],
      pdfUrl:[],
      chosenTemplate:"",
      offerDealId:"",
      offererName:"",
      offererTitle:"",
      customerName:"",
      customerTitle:"",
      offerTitle:"",
      editor1Text:"",
      editor2Text:"",
      editor3Text:"",
      showTotalPriceStatus:true,
      showTotalDiscountStatus:true,
      showOtherTaxStatus:true,
      refNo:"",
      otherTaxes:[],
      fileId:{},


      pickedDealDate: '',
      predefinedDate: {},
      activityDelayDay: "",
      activityDelayHour: "",
      activityDelayMinute: "",
      activityDateWorkflow:"",
      activityTime2:"",
      timeNumber: '',
      timeAfter: '',
      activityTime1:"",
    };
  },
  computed: {
    ...mapState([
      "baseUrl",
      "editLine",
      "maxMobilSize",
      "maxTabletSize",
      "windowWidth",
    ]),
    ...mapGetters(["localeLang"]),
    listenState() {
      return this.$store.state.editLine;
    },
    listenStateStatus() {
      return this.$store.state.editLineStatu;
    },
  },
  methods: {
    ...mapActions(["updateDealId", "updateLoading", "upsertReminder"]),

    fromCreationDateSection(){
      // console.log('fromCreationDate')
      $('#fromCreationDateSectionID').css('pointer-events', 'auto')
    },
    predefinedDateSection(){
      // console.log('predefinedDate')
      $('#predefinedDateSectionID').css('pointer-events', 'auto')
    },
    changeCurrency(event) {
     
      for (var i in this.selectedProductList) {
        var getProductDetail = this.product.find(
          (p) => p._id.$oid == this.selectedProductList[i].productId.$oid
        );
        if (getProductDetail.prices !== undefined) {
          var productPrice = getProductDetail.prices.find(
            (p) => p.currency == this.deal["currency"]
          );
          if (productPrice) {
            this.selectedProductList[i].itemPrice = productPrice.price;
          } else {
            this.selectedProductList[i].itemPrice = 0;
          }
        } else {
          this.selectedProductList[i].itemPrice = 0;
        }
      }
      this.updateProductPriceList();
    },
    updateProductPriceList() {
      this.deal.value = 0;
      for (var i in this.selectedProductList) {
        if (this.selectedProductList[i].discountPercentage > 100) {
          this.selectedProductList[i].discountPercentage = 100;
        }
        if (this.selectedProductList[i].discountPercentage == "") {
          this.selectedProductList[i].discountPercentage = 0;
        }
        this.selectedProductList[i].totalPrice =
          this.selectedProductList[i].itemPrice *
            this.selectedProductList[i].quantity -
          (this.selectedProductList[i].itemPrice *
            this.selectedProductList[i].quantity *
            this.selectedProductList[i].discountPercentage) /
            100;

        this.deal.value =
          this.deal.value + this.selectedProductList[i].totalPrice;
        this.deal.value = parseFloat(this.deal.value.toFixed(2));
        this.selectedProductList[i].totalPrice = parseFloat(
          this.selectedProductList[i].totalPrice.toFixed(2)
        );
      }
    },

    addNoteFunc() {
      let dataObje = {};
      dataObje["dealId"] = this.dealId;
      dataObje["noteText"] = this.addNote;
      dataObje["note"] = this.addNote;
      dataObje["notePostUrl"] = "upsertDealNote";
      if (this.addNote === "") {
        this.$notify({
          group: "foo",
          type: "warn",
          title: this.$ml.get("NOTE_CANNOT_BE_EMPTY"),
          text: this.$ml.get("PLEASE_INSERT_A_VALID_NOTE"),
        });
        return false;
      }

      axios({
        method: "POST",
        url: "/addNote",
        baseURL: this.baseUrl,
        data: dataObje,
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (res.data.status.code == 0) {
            this.addNote = "";

            this.deal["notes"].push(res.data.content.note);

            this.$notify({
              group: "foo",
              type: "success",
              title: this.$ml.get("SUCCESSFUL"),
              text: res.data.status.desc,
            });
          } else {
            this.$notify({
              group: "foo",
              type: "warning",
              title: this.$ml.get("WARNING"),
              text: res.data.status.desc,
            });
          }
        });
    },
    setResult(result, type) {
      if (type === "contact") {
        if (result.sn !== undefined) {
          this.contactKeyword = result.n + " " + result.sn;
          this.selectContact = result.n + " " + result.sn;
        } else {
          this.contactKeyword = result.n;
          this.selectContact = result.n;
        }
        this.isHiddenContact = false;
        this.contactId = result._id.$oid;

        if (result.organizationName !== undefined) {
          this.organizationId = result.organization.$oid;
          this.organizationsKeyword = result.organizationName;
          this.organizationsWord = result.organizationName;
          this.selectOrganization = result.organizationName;
        }
      }
      if (type === "organization") {
        this.organizationsKeyword = result.name;
        this.organizationsWord = result.name;
        this.isHiddenOrganization = false;
        this.organizationId = result._id.$oid;
        this.selectOrganization = result.name;
      }
      if (type === "product") {
 
        let originalProductObj = result
        let array =[]
        for (const property in result) {
          if(result[property].field_type===12){
            array.push(result[property])
          }
          originalProductObj['customFieldTaxes']=array
        }        
        this.orjinalProductList.push(originalProductObj);

        if (this.product.length < 1) {
          this.deal["value"] = null;
        }
        this.isHiddenProduct = false;
        this.productKeyword = "";
        this.productId = result._id.$oid;
        this.selectProduct = result.name;

        if (
          this.product.filter((m) => m._id.$oid === this.productId).length === 0
        ) {
          this.product.push(result);
          let obj = {};
          var currencyIs = false;

          for (var res in result.prices) {
            if (result.prices[res].currency == this.deal["currency"]) {
              currencyIs = true;
              this.deal["value"] += result.prices[res].price;
              this.deal["value"] = parseFloat(this.deal["value"].toFixed(2));
              this.deal["currency"] = result.prices[res].currency;
              obj["itemPrice"] = result.prices[res].price;
              obj["quantity"] = 1;
              obj["discountPercentage"] = 0;
              obj["totalPrice"] = result.prices[res].price;
              obj["productId"] = { $oid: this.productId };
            }
          }
          if (!currencyIs) {
            this.deal["value"] += 0;
            //this.deal['currency']=1
            obj["itemPrice"] = 0;
            obj["quantity"] = 1;
            obj["totalPrice"] = 0;
            obj["discountPercentage"] = 0;
            obj["productId"] = { $oid: this.productId };
          }
          let concatedObj = {...obj, ...result}
          this.selectedProductList.push(concatedObj);
        }
      }
    },
    removeProduct(index) {
      this.product.splice(index, 1);
      this.selectedProductList.splice(index, 1);
      this.updateProductPriceList();
    },
    quickProduct() {
      axios({
        method: "POST",
        url: "/quickFilterProduct",
        baseURL: this.baseUrl,
        data: {
          search: this.productKeyword,
        },
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (!res.data.status) {
            this.$router.push("/logout");
          }
          if (res.data.status.code == 0) {
            this.items = res.data.content.products;
            this.isHiddenProduct = true;
          } else {
          }
        });
    },
    getOrganization(){
      let id=this.organizationId   
      axios({
          method:'POST',
          url:'/getOrganization',
          baseURL: this.baseUrl,
          data: {
              organizationId:id,
          },
          withCredentials:true
      }).then((res)=>{
          return res
      }).then((res)=>{
          if(res.data.status===false){
          this.$router.push('/logout')
          }
          if(res.data.status.code==0){
            this.organizationData=res.data.content.organization
            this.personData=res.data.content.organization.contacts
                
          }else{
              this.$notify({ 
                  group: 'foo',
                  type: 'error', 
                  title: this.$ml.get('ERROR'),
                  text: res.data.status.desc 
              })
                
          }
      })
    },
    activityProceed(){
      if(this.deal['title'] === '' || this.deal['title'] === undefined){
        this.$notify({ 
          group: 'foo',
          type: 'warn', 
          title: this.$ml.get('WARNING'),
          text: this.$ml.get('PLEASE_ENTER_A_DEAL_NAME')
        })

        return false
      }

      if(this.assignedValue === "0"){
        this.$notify({ 
          group: 'foo',
          type: 'warn', 
          title: this.$ml.get('WARNING'),
          text: this.$ml.get('PLEASE_SELECT_AN_ASSIGNER')
        })

        return false
      }

      if(this.pickedDealDate == '' || this.pickedDealDate == undefined){
        this.$notify({ 
          group: 'foo',
          type: 'warn', 
          title: this.$ml.get('WARNING'),
          text: 'Lütfen gerekli tarih kısımlarını giriniz.'
        })

        return false

      }else{
        
      }

      let date = {}
      let emptyDate = ''
      let dealObject = {}

      if((this.activityDateWorkflow == '') && (this.activityDelayDay == "" && this.activityDelayHour == "" && this.activityDelayMinute == "")){
        // console.log('Tarihler boşş')
        // date = emptyDate
        // dealObject.delay_date_for_rindap = date
      }else if(this.activityDelayDay != "" || this.activityDelayHour != "" || this.activityDelayMinute != ""){

        const day = Math.floor(this.activityDelayDay * 1440);
        const hour = Math.floor(this.activityDelayHour * 60);
        const minute = Math.floor(this.activityDelayMinute);
        date = day + hour + minute
        dealObject.dueDatebyTime = date

      }else if(this.activityDateWorkflow != ''){
        const activityDateWorkflowVal = new Date(this.activityDateWorkflow)
        const workflowActivityDate = moment(activityDateWorkflowVal).format('DD MMMM YYYY')
        const dateString = workflowActivityDate.concat(' ', this.activityTime2, ' UTC')
        const event = new Date(dateString);
        const dueDateString = event.toISOString()
        
        date = {
          $date: dueDateString
        }
        dealObject.dueDate = date
      }

      dealObject.title = this.deal['title'],
      dealObject.note = this.note,
      dealObject.productList = this.selectedProductList
      dealObject.value = this.deal['value']
      dealObject.currency = this.deal['currency']
      dealObject.rate = parseInt(this.deal['rate'])
      dealObject.source = this.deal['source']
      dealObject.status = this.deal['status']
      dealObject.dealOwner = {
        $oid: this.assignedValue
      },  
      
      dealObject.stageId = this.deal["stageId"]

      this.$emit('change',dealObject)
      $('#addAction').modal('hide')
      this.$emit('closeBtnDeal')

    },
    closeButton(){
      this.note = ''
      this.assignedValueTitle = "Seçiniz"
      this.pickedDealDate = ''
      this.timeNumber = ''
      this.timeAfter = ''
      this.deal = {
        stageId: 1,
        value: 0,
        currency: localStorage.defaultCurrency,
        rate: "0",
        source: "0",
        notes: [],
        dealOwner:"",
        title:"",
      },
      this.$emit('closeBtn')
    },
    selectStage: function (event) {
      this.deal["stageId"] = parseInt(event.srcElement.parentElement.id);
    },
    scrollfunctionOfGrid: function (scrollYEmit, clientHeightEmit, scrollHeightEmit) {
      this.bottom = this.bottomVisible(scrollYEmit, clientHeightEmit, scrollHeightEmit);
    },
    bottomVisible(scrollYEmit, clientHeightEmit, scrollHeightEmit) {
      const scrollY = scrollYEmit;
      const visible = clientHeightEmit;
      const pageHeight = scrollHeightEmit;
      const bottomOfPage = visible + scrollY >= pageHeight;

      return bottomOfPage || pageHeight < visible;
    },
  },
  mounted() {
    $(".mincrm-dynamic-tabs").bootstrapDynamicTabs();

    if(Object.keys(this.updateAction).length !== 0){

      this.deal['title']=this.updateAction.dealInputObj.title
      this.note=this.updateAction.dealInputObj.note
      this.deal['stageId']=this.updateAction.dealInputObj.stageId
      this.deal['value']=this.updateAction.dealInputObj.value
      this.deal['currency']=this.updateAction.dealInputObj.currency

      if(this.updateAction.dealInputObj.dealOwner!==undefined){
        this.assignedValue=this.updateAction.dealInputObj.dealOwner.$oid
        this.assignedValueTitle=this.users.find(usr => usr._id['$oid']==this.assignedValue).name+" "+this.users.find(usr => usr._id['$oid']==this.assignedValue).surName
      }
      if(this.updateAction.dealInputObj.dueDatebyTime!==undefined){
          this.pickedDealDate='fromCreationDate'
          let time=this.updateAction.dealInputObj.dueDatebyTime
          this.activityDelayDay=Math.floor(time/(60*24)) 
          this.activityDelayHour=Math.floor((time-(this.activityDelayDay*(60*24)))/60)
          this.activityDelayMinute=time-(this.activityDelayHour*60)-(this.activityDelayDay*(60*24)) 
      }
      if(this.updateAction.dealInputObj.duration!==undefined){
          this.activityTime1=this.updateAction.dealInputObj.duration
      }
      if(this.updateAction.dealInputObj.source!==undefined){
        this.deal['source']=this.updateAction.dealInputObj.source
      }
      if(this.updateAction.dealInputObj.rate!==undefined){
        this.deal['rate']=this.updateAction.dealInputObj.rate.toString()
      }
      if(this.updateAction.dealInputObj.productList!==undefined){
        this.selectedProductList=this.updateAction.dealInputObj.productList
      }
      
    }
  },
  watch: {
    productKeyword: _.debounce(function (addr) {
      if (this.productKeyword === "") {
        this.isHiddenProduct = false;
      }
      if (this.selectProduct !== this.productKeyword) {
        this.quickProduct();
      }
    }, 300),

    modalClear: function (val) {
      if (val) {
        this.clear();
      }
    },
    listenState(data) {
      
    },
    listenStateStatus(data) {
      if (data === false) {
        this.$store.state.editLine = [];
        this.clear();
      }
    },
  },
  created() {
    this.assignedValue="0"
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.my-custom-scrollbar {
  position: relative;
  height: 200px;
  overflow: auto;
}
.tabloilk {
  width: 100%;
}
.table-wrapper-scroll-y {
  display: block;
}
.h36 {
  height: 36px;
}
.hw36 {
  height: 36px;
  width: 36px;
}
.gri {
  color: #9098a1;
}
.btn-onizleme {
  border: 2px solid #1991eb;
  box-sizing: border-box;
  border-radius: 6px;
  color: #1991eb;
}
.save-and-create-bid {
  background-color: #3767a0;
  color: white;
}
.black {
  color: #000000;
}
.fs16 {
  font-size: 16px;
}
.logo {
  width: 149px;
  height: 102px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}
.borderr {
  border: 1px solid #a5abb3;
  box-sizing: border-box;
  border-radius: 8px;
}
.label-title-color {
  color: #7e8187;
}
.label-desc-color {
  color: #354052;
}
.company-info-color {
  color: #93959a;
}
/* .product-add-price-table tr td{
    width:185px;
} */
.currency-group > input {
  width: 200px;
}
.currency-group > select {
  background-color: #dedfe1;
  height: 34px;
}
.modal-header {
  background-color: #d7e3f4;
}
.modal-header li {
  font-size: 16px;
  margin-right: 5px;
}
.modal-header li a {
  color: #93959a;
  text-decoration: none;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 13px;
}
.modal-header li a.active {
  color: #5b5f63;
  font-weight: bold;
  border-bottom: 3px solid #1991eb;
}

.dealStatus div.statu {
  padding: 0;
}
.dealStatus .statu .active {
  color: white;
}
.dealStatus div.statu:nth-child(1) .active {
  background-color: #53a3f2;
}
.dealStatus div.statu:nth-child(2) .active {
  background-color: #3c89d8;
}
.dealStatus div.statu:nth-child(3) .active {
  background-color: #2f6aa8;
}
.dealStatus div.statu:nth-child(4) .active {
  background-color: #214c78;
}

.mcTable {
  border-spacing: 0;
  width: 100%;
  text-align: center;
}
.mcTable tbody {
  background-color: #dde0e4;
}
.mcTable thead {
  background-color: #fff;
}
.mcTable tr {
  margin-right: 3px;
}
.mcTable thead tr th {
  padding: 9px 4px;
  margin-right: 3px;
  font-size: 11px;
  color: #53565e;
}
.mcTable tbody tr {
  border-bottom: 0.5px solid #bec0c3;
}
.mcTable tbody tr:last-child {
  border: none;
}
.mcTable tbody tr td:last-child {
  cursor: pointer;
}
.mcTable tbody tr td {
  margin-right: 3px;
  font-size: 11px;
  padding: 7px 3px;
}

.dealStatus div.statu:first-child button {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.dealStatus div.statu:last-child button {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.dealStatus div.statu button {
  border-radius: 0;
}
.personTable {
  min-height: 350px;
  min-width: 655px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 4px;
}
.listPerson {
  display: flex;
  background: #E9EAEB;
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  align-items: center;
}
.dealInput{
  height: 30px;
  width: 200px;
  border: 1px solid rgb(206, 205, 205);
  border-radius: 3px;
}

@media (min-width: 768px) {
  .dealStatus div.statu button {
    padding: 10px;
    border-radius: 0;
    background-color: #f4f4f4;
    color: #354052;
  }
  .dealStatus div.statu button:after {
    content: "";
    border-right: 0.5px solid #979797;
    position: absolute;
    right: 0;
    height: 70%;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
  }
  .dealStatus div.statu:last-child button:after {
    border: 1px solid transparent;
  }
}

@media (max-width: 768px) {
  .dealStatus div.statu button {
    background-color: inherit;
    color: #7e8086;
    font-size: 13px !important;
  }
}
</style>
